'use client'

import { motion, AnimatePresence } from 'framer-motion'
import { Header } from '@/widgets/header'
import { NavigationBar } from '@/shared/ui/navigation-bar'
import { useScrollDirection } from '@/shared/lib/hooks/useScrollDirection'

export const SmartHeader = () => {
  const { scrollDirection, isScrolled } = useScrollDirection()

  // Показываем навигацию если:
  // 1. Прокрутка вверх
  // 2. Или находимся в самом верху страницы
  const shouldShowNav = scrollDirection === 'up' || !isScrolled

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Основной хедер - всегда закреплен */}
      <div className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b">
        <Header />
      </div>

      {/* Навигационная панель - скрывается/показывается */}
      <AnimatePresence mode="wait">
        {shouldShowNav && (
          <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -100, opacity: 0 }}
            transition={{
              duration: 0.3,
              ease: [0.25, 0.46, 0.45, 0.94] // easeOutCubic
            }}
          >
            <div className="bg-muted/30 backdrop-blur border-b">
              <NavigationBar />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
